<template lang="pug">
div.size-editor.mb-2
  v-btn-toggle.mb-2(v-model="paperMode" @change="paperModeChanged" dense)
    v-btn(small text value="standard") Standard
    v-btn(small text value="custom") Custom

  template(v-if="paperMode == 'standard'")
    v-select.paper-format(dense outlined label="Size" :items="componentOptions" item-text="name" item-value="value" @change="updatePageDimensions" v-model="paperFormat" hide-details)
    v-select.paper-orientation.mt-2(dense outlined label="Orientation" :items="orientationOptions" item-text="name" item-value="value" @change="updatePageDimensions" v-model="paperOrientation" hide-details)

  template(v-else)
    .d-flex
      v-text-field.paper-width.mr-2(dense outlined label="Width" suffix="in." type="number" step="0.01" min="0" v-model.number="templateWidth" hide-details)
      v-text-field.paper-height(dense outlined label="Height" suffix="in." type="number" step="0.01" min="0" v-model.number="templateHeight" hide-details)
</template>

<script>
  import { isString, find } from 'lodash'
  import { mapActions } from 'vuex'

  const componentOptions = [
    { value: 'poker', name: 'Poker-sized Cards',
      width: 2.5, height: 3.5 },
    { value: 'a4', name: 'Whole Page (A4)',
      width: 8.3, height: 11.7 },
    { value: 'letter', name: 'Whole Page (Letter)',
      width: 8.5, height: 11 },
    { value: 'universal', name: 'Whole Page (Universal)',
      width: 8.3, height: 11 },
  ]

  const orientationOptions = [
    { name: "Portrait", value: 'portrait' },
    { name: "Landscape", value: 'landscape' }
  ]

  export default {
    props: {
      template: {
        type: Object,
        required: true
      }
    },

    data() {
      const size = this.template.size || {} // make sure we have defaults

      return {
        componentOptions,
        orientationOptions,
        paperMode: size.paperMode || "standard",
        paperFormat: size.paperFormat || "poker",
        paperOrientation: size.paperOrientation || "landscape",
      }
    },

    computed: {
      templateWidth: {
        get() { return this.template.size.w },
        set(newWidth) {
          if(isString(newWidth) || newWidth < 0) { newWidth = 0 }
          const newSize = { ...this.template.size, w: newWidth  }
          this.patchTemplate({ ...this.template, size: newSize })
        }
      },

      templateHeight: {
        get() { return this.template.size.h },
        set(newHeight) {
          if(isString(newHeight) || newHeight < 0) { newHeight = 0 }
          const newSize = { ...this.template.size, h: newHeight }
          this.patchTemplate({ ...this.template, size: newSize })
        }
      }
    },

    methods: {
      ...mapActions(["patchTemplate"]),

      paperModeChanged() {
        if(this.paperMode == "standard") {
          this.paperFormat = "poker"
          this.paperOrientation = "portrait"
          this.updatePageDimensions()
        } else {
          const size = {
            h: this.template.size.h,
            w: this.template.size.w,
            paperMode: this.paperMode
          }
          this.patchTemplate({ ...this.template, size })
        }
      },

      updatePageDimensions() {
        if(this.paperFormat.length == 0) { return }

        const
          format = find(componentOptions, { value: this.paperFormat }),
          width = format.width,
          height = format.height,
          smallerDimension = Math.min(width, height),
          largerDimension = Math.max(width, height)

        let size = {
          paperFormat: this.paperFormat,
          paperMode: this.paperMode,
          paperOrientation: this.paperOrientation
        }

        if(this.paperOrientation == 'portrait') {
          size = {...size,
            w: smallerDimension,
            h: largerDimension
          }
        } else if(this.paperOrientation == 'landscape') {
          size = {...size,
            w: largerDimension,
            h: smallerDimension,
          }
        }

        this.patchTemplate({ ...this.template, size })
      }
    }
  }
</script>
